(() => {
  'use strict';

  // Const
  // -----
  //const MAX_VIEWPORT_WIDTH = 2048;

  window.SMALL_MOBILE_WIDTH = 360;
  window.PORTRAIT_MOBILE_WIDTH = 480;
  window.LARGE_PORTRAIT_MOBILE_WIDTH = 700;
  window.LANDSCAPE_MOBILE_WIDTH = 800;
  window.PORTRAIT_TABLET_WIDTH = 768;
  window.LANDSCAPE_SMALL_TABLET_WIDTH = 900;
  window.LANDSCAPE_TABLET_WIDTH = 980;
  window.DESKTOP_WIDTH = 1024;
  window.DESKTOP_MID_WIDTH = 1160;
  window.DESKTOP_BIG_WIDTH = 1280;
  window.DESKTOP_WIDE_WIDTH = 1366;

  // Selectors
  // ---------
  window.$WINDOW = $(window);
  window.$DOCUMENT = $(document);
  window.$HTML = $(document.documentElement);
  window.$BODY = $(document.body);
  window.$HEADER = $('.header');
  window.$HEADER_MENU = $('.header-menu');
  window.$MENU_CHECKBOX = $('.header-menu-checkbox');

  // Helpers
  // -------
  $WINDOW
    .on('calcSizes', () => {
      window.VIEWPORT_WIDTH = document.documentElement.clientWidth || Math.round(window.visualViewport.width) || $WINDOW.width();
      window.WINDOW_HEIGHT = $WINDOW.height();
      window.HEADER_HEIGHT = $HEADER.height();
    })
    .on('resize', () => {
      $WINDOW.trigger('calcSizes');
    })
    .trigger('calcSizes');

  /**
   * @return boolean
   */
  window.IS_DESKTOP_WIDE_WIDTH = () => VIEWPORT_WIDTH >= DESKTOP_WIDE_WIDTH;
  /**
   * @return boolean
   */
  window.IS_DESKTOP_BIG_WIDTH = () => VIEWPORT_WIDTH >= DESKTOP_BIG_WIDTH;
  /**
   * @return boolean
   */
  window.IS_DESKTOP_MID_WIDTH = () => VIEWPORT_WIDTH >= DESKTOP_MID_WIDTH;
  /**
   * @return boolean
   */
  window.IS_DESKTOP_WIDTH = () => VIEWPORT_WIDTH >= DESKTOP_WIDTH;
  /**
   * @return boolean
   */
  window.IS_WIDTH_MORE_DESKTOP = () => VIEWPORT_WIDTH > DESKTOP_WIDTH;
  /**
   * @return boolean
   */
  window.IS_TABLET_WIDTH = () => (VIEWPORT_WIDTH >= PORTRAIT_TABLET_WIDTH && VIEWPORT_WIDTH < DESKTOP_WIDTH);
  /**
   * @return boolean
   */
  window.IS_WIDTH_LESS_PORTRAIT_TABLET = () => VIEWPORT_WIDTH < PORTRAIT_TABLET_WIDTH;
  /**
   * @return boolean
   */
  window.IS_LANDSCAPE_TABLET_WIDTH = () => VIEWPORT_WIDTH < LANDSCAPE_TABLET_WIDTH;
  /**
   * @return boolean
   */
  window.IS_LANDSCAPE_SMALL_TABLET_WIDTH = () => VIEWPORT_WIDTH < LANDSCAPE_SMALL_TABLET_WIDTH;
  /**
   * @return boolean
   */
  window.IS_MOBILE_WIDTH = () => VIEWPORT_WIDTH < LANDSCAPE_MOBILE_WIDTH;
  /**
   * @return boolean
   */
  window.IS_LARGE_PORTRAIT_MOBILE_WIDTH = () => VIEWPORT_WIDTH < LARGE_PORTRAIT_MOBILE_WIDTH;
  /**
   * @return boolean
   */
  window.IS_PORTRAIT_MOBILE_WIDTH = () => VIEWPORT_WIDTH < PORTRAIT_MOBILE_WIDTH;
  /**
   * @return boolean
   */
  window.IS_SMALL_MOBILE_WIDTH = () => VIEWPORT_WIDTH < SMALL_MOBILE_WIDTH;


  // Defaults
  // --------
  const firstBlockImageSelector = '.first-block-item > div:first-child span[data-lazy-src]',
        slickBaseSettings = {
          elementAsContext: true,
          slider: '> div:first-child',
          appendArrows: '.slick-arrows',
          appendDots: '.slick-dots',
          dotsClass: '',
          autoplay: true,
          autoplaySpeed: 4000,
          speed: 300,
          centerMode: false,
          centerPadding: '0px',
          cssEase: 'ease-in-out',
          prevArrow: '<div class="prev"><span></span></div>',
          nextArrow: '<div class="next"><span></span></div>',
          pauseOnDotsHover: true,
          customPaging: () => '<div></div>',
          draggable: true,
          swipeToSlide: true,
          touchThreshold: 100
        },
        unveilSettings = {
          attribute: 'lazySrc',
          placeholder: '',
          offset: 20,
          throttle: 200
        },
        plyrSettings = {
          autoplay: false,
          //volume: 0.5, // не работает. вынес в переменную для отдельных команд
          invertTime: false,
          iconUrl: '/i/plyr.svg',
          controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
          settings: [],
          tooltips: {
            seek: false,
          },
        },
        plyrDefaultVolume = 0.5;


  // Masked input
  // ------------
  $('input[type="date"]').attr('type', 'text');

  Inputmask.extendAliases({
    'phone-mask': {
      regex: '\\+1 \\(\\d{3}\\) \\d{3}\\-\\d{4}',
      placeholder: '+1 (___) ___-____'
    }
  });

  // Phone
  $('input[type="tel"], input[autocomplete="tel"]').inputmask('phone-mask');



  $WINDOW
    .one('load', () => {
      $WINDOW.trigger('calcSizes');
      $DOCUMENT.trigger('headerEvents');
    })
    /*.on('structureScale', () => {
      $('.structure').css('transform', (VIEWPORT_WIDTH > MAX_VIEWPORT_WIDTH ? 'scale('.concat(VIEWPORT_WIDTH / MAX_VIEWPORT_WIDTH, ')') : ''));
    })*/
    .on('resize', () => {
      //$WINDOW.trigger('structureScale');
      $DOCUMENT
        .trigger('headerEvents')
        .trigger('firstBlockResize');
    })/*
    .trigger('structureScale')*/;


  $DOCUMENT
    .ready(() => {
      // Header menu button
      // ------------------
      $MENU_CHECKBOX
        .on('change', e => {
          e.currentTarget.checked ? $BODY.addClass('menu-is-opened') : $BODY.removeClass('menu-is-opened');
        })
        .prop({'checked': false, 'disabled': false})
        .trigger('change');


      // Portfolio images comparison slider fix for touch devices
      // --------------------------------------------------------
      Plyr.rangeTouch.setup('.portfolio .vitrine-item-image input', {addCSS: false, watch: false});


      // Video player init
      // -----------------
      const videos = Plyr.setup('.js-video-player', plyrSettings);

      if (videos !== null)
        videos.forEach(plyr => {
          if (plyr.type === 'video') {
            plyr.volume = plyrDefaultVolume;

            const cssClass = 'plyr--fullscreen-entered';

            plyr.on('enterfullscreen', e => { e.currentTarget.classList.add(cssClass); });
            plyr.on('exitfullscreen', e => { e.currentTarget.classList.remove(cssClass); });
          }
        });


      // Team rotator
      // ------------
      $('.team').slick($.extend({}, slickBaseSettings, {
        autoplay: false,
        //infinite: false,
        adaptiveHeight: true,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: DESKTOP_BIG_WIDTH,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: LANDSCAPE_SMALL_TABLET_WIDTH,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: PORTRAIT_MOBILE_WIDTH,
            settings: {
              slidesToShow: 1,
            }
          },
        ],
      }));


      // Lazy load
      // ---------
      $(firstBlockImageSelector).unveil($.extend({}, unveilSettings, {
        attribute: 'lazySrcSm',
        offset: 0,
        breakpoints: [
          {
            minWidth: PORTRAIT_MOBILE_WIDTH,
            attribute: 'lazySrcMd'
          },
          {
            minWidth: DESKTOP_WIDTH,
            attribute: 'lazySrc'
          }
        ]
      }));

      $('.js-visible, .subheader, .subsubheader, .subsubsubheader, .vitrine, .vitrine-item, .vitrine-item-image [data-lazy-src], .video-frame > a span[data-lazy-src], .gallery > div:first-child > div, .gallery-item img, .about-incut [data-lazy-src], .faq-divided, .faq-list').unveil(unveilSettings);
      $('.incut-image')
        .one('load.unveil', (e, data) => {
          if (data)
            $(e.target).css('--image', 'url(\''.concat(data.targetSrc, '\')'));
        })
        .unveil($.extend({}, unveilSettings, {
          //offset: 75,
          backgroundSet: false
        }));
    })

    // Header events
    // -------------
    .on('headerEvents', () => {
      $BODY.css('--header-height', HEADER_HEIGHT + 'px');
      $HEADER.addClass('fixed');

      if (IS_DESKTOP_BIG_WIDTH()) {
        if (!$BODY.hasClass('is-desktop-events')) {
          $BODY
            .addClass('is-desktop-events')
            .removeClass('is-mobile-events');

          $MENU_CHECKBOX.prop('checked', false).trigger('change');

          $HEADER_MENU
            .find('li').removeClass('is-hovered')
            .find('ul').removeAttr('style');
        }
      }
      else {
        if (!$BODY.hasClass('is-mobile-events')) {
          $BODY
            .addClass('is-mobile-events')
            .removeClass('is-desktop-events');

          $HEADER_MENU.find('li.is-opened:not(.is-hovered)').addClass('is-hovered');
        }

        if (!$HEADER_MENU.data('mobileEventsInitialized')) {
          $HEADER_MENU.data('mobileEventsInitialized', true);

          // Header menu mobile events
          // -------------------------
          $DOCUMENT
            // Close header menu
            .on('click.closeHeaderMenu', e => {
              if (!($(e.target).closest('.header-menu-checkbox').length || $(e.target).closest('.header-menu-button').length || $(e.target).closest('.header-menu-button-wrapper + div > div').length)) {
                e.stopPropagation();

                $MENU_CHECKBOX.prop('checked', false).trigger('change');
              }
            });
        }
      }
    })

    // Header menu events
    // ------------------
    .on('click.headerMenu', '.header-menu > ul a, .header-menu > ul div > span, .header-menu > ul .dropmarker', e => {
      e.preventDefault();

      let $self = $(e.currentTarget),
          $parent = $self.closest('li'),
          isWithDropdown = $parent.hasClass('with-dropdown'),
          isOnHover = $parent.hasClass('is-hovered');

      if ($self.prop('tagName').toUpperCase() === 'A') {
        let href = $self.attr('href'),
            hash = [...href.matchAll(/#(.+)/g)];

        if (!hash.length || (getUrl(href) != getUrl()))
          location.href = href;
        else {
          let $element = $('#'.concat(hash[0][1]));

          if ($element.length) {
            if (window.history && window.history.pushState)
              window.history.pushState(null, '', hash[0][0]);

            $MENU_CHECKBOX.prop('checked', false).trigger('change');
            $DOCUMENT.trigger('scrollTo', [$element]);
          }
        }
      }
      else if (isWithDropdown) {
        if (isOnHover)
          $parent.removeClass('is-hovered').children('ul').slideUp(300);
        else {
          //$parent.siblings().removeClass('is-hovered').children('ul').slideUp(300);
          $parent.addClass('is-hovered').children('ul').slideDown(300);
        }
      }
    })

    // Callback form open
    // ------------------
    .on('click.callbackFormButton', '.btn-callback', e => {
      e.preventDefault();

      $.fancybox.open({
        type: 'inline',
        src: '#callback-popup-form'
      });
    })

    // First block events
    // ------------------
    .on('firstBlockResize', () => {
      clearTimeout(window.firstBlockResizeTimeout);
      window.firstBlockResizeTimeout = setTimeout(
        () => {
          //console.log('firstBlockResizeTimeout - ' + Date.now());

          let attribute = 'data-lazy-src';

          switch (true) {
            case (IS_PORTRAIT_MOBILE_WIDTH()):
              attribute = 'data-lazy-src-sm';
              break;

            case (!IS_DESKTOP_WIDTH()):
              attribute = 'data-lazy-src-md';
              break;
          }

          $(firstBlockImageSelector + '.unveil-loaded').each((i, element) => {
            element.style.backgroundImage = 'url(' + element.attributes[attribute].value + ')';
          });

          clearTimeout(window.firstBlockResizeTimeout);
        },
        300
      );
    })

    // Portfolio images comparison slider
    // ----------------------------------
    .on('input change', '.portfolio .vitrine-item-image input', e => {
      let $input = $(e.currentTarget);

      $input.closest('.vitrine-item-image').css('--divider-left', $input.val() + '%');
    })
    .on('dblclick', '.portfolio .vitrine-item-image input', e => {
      $(e.currentTarget).val(50).trigger('change');
    })

    // Video frame load
    // ----------------
    .on('click.videoFrame', '.video-frame > a', e => {
      e.preventDefault();

      let $self = $(e.currentTarget),
          $container = $self.parent(),
          $video = $container.find('[data-src]'),
          platform = $self.data('platform') || false,
          videoConfig = $video.data('plyrConfig') || {},
          afterLoadCallback = video => {
            if (platform) {
              if (platform === 'rutube') {
                video.contentWindow.postMessage(JSON.stringify({type: 'player:setCurrentTime', data: {time: 0}}), '*');
                //video.contentWindow.postMessage(JSON.stringify({type: 'player:setVolume', data: {volume: 0.5}}), '*');
                video.contentWindow.postMessage(JSON.stringify({type: 'player:play', data: {}}), '*');
              }
            }
            else {
              const player = new Plyr(video, $.extend({}, plyrSettings, videoConfig, {
                poster: '',
              }));

              player.volume = plyrDefaultVolume;

              player.on('ready', () => {
                player.play();
              });
            }
          };

      if (($self.data('popup') !== undefined) || (IS_LANDSCAPE_SMALL_TABLET_WIDTH() && ($self.outerWidth() <= (VIEWPORT_WIDTH - 25) / 2))) {
        const ratioHeight = (!platform && videoConfig.ratio) ? parseFloat(videoConfig.ratio.split(':').at(1)) : undefined;

        $.fancybox.open({
          type: (platform ? 'iframe' : 'video'),
          src: $video.data('src'),
          video: {
            autoStart: false,
          },
          ratio: ratioHeight ? (100 / ratioHeight) : undefined,
          afterLoad: fancybox => {
            afterLoadCallback((platform ? fancybox.current.$iframe : fancybox.current.$content.children('video')).get(0));
          },
        });
      }
      else {
        if (platform)
          $video.on('load', e => { afterLoadCallback(e.currentTarget); });

        $video.attr('src', $video.data('src'));
        $container.addClass('active');
      }
    })

    // Faq list
    // --------
    .on('click.faqList', '.faq-list > div', e => {
      e.preventDefault();

      $(e.currentTarget).toggleClass('active').children('div:last-child').slideToggle(300);
    })

    // Scroll to
    // ---------
    .on('scrollTo', (e, $element, speed, offset) => {
      if ($element === undefined)
        $element = $(e.target);

      if (speed === undefined)
        speed = $element.data('scrollSpeed') || 300;

      if (offset === undefined)
        offset = $element.data('scrollOffset') || 0;

      $WINDOW.scrollTo($element, {axis: 'y', duration: speed, offset: parseInt(offset) - HEADER_HEIGHT});
    })
    .on('click.jsScrollTo', '.js-scroll-to', e => {
      e.preventDefault();

      let $link = $(e.currentTarget),
          $element = $($link.attr('href').substring($link.attr('href').lastIndexOf('#'))),
          speed = $link.data('scrollSpeed') || 300,
          offset = $link.data('scrollOffset') || undefined;

      $DOCUMENT.trigger('scrollTo', [$element, speed, offset]);
    })

    // Tabs
    // ----
    .on('click.jsTabs', '.js-tabs a', e => {
      e.preventDefault();

      let $self = $(e.currentTarget);

      if (!$self.hasClass('active')) {
        let $container = $self.closest('.js-tabs'),
            $links = $container.find('a'),
            $destination = !!$container.data('tabsDest') ? $($container.data('tabsDest')) : $container.next(),
            cssClass = $container.data('tabCssClass') || 'active';

        $self.addClass('active');
        $links.not($self).removeClass('active');
        $destination.children().removeClass(cssClass).eq($links.index($self)).addClass(cssClass);
      }
    })

    // Contact sticky widget
    // ---------------------
    .on('click.contactWidget', '.contact-widget-item .with-popup', e => {
      if (IS_DESKTOP || IS_DESKTOP_WIDTH()) {
        e.preventDefault();

        let $container = $('#contact-widget-popup'),
            openPopup = () => {
              $.fancybox.open({type: 'inline', src: $container});
            };

        if (!$container.hasClass('loading')) {
          if (!$container.hasClass('loaded')) {
            $container.addClass('loading');
            $.mouseLoader(true);

            $.ajax({
              type: 'POST',
              url: '/ajax/render_content/',
              data: {
                ajaxRender: 'contactWidgetPopupContent',
              },
              dataType: 'html'
            })
              .done(data => {
                $.mouseLoader(false);

                $container.addClass('loaded').html(data);
                openPopup();
              })
              .fail(() => {
                $.mouseLoader(false);
                alert('Во время загрузки данных возникла ошибка, обновите страницу или попробуйте позже.');
              })
              .always(() => {
                $container.removeClass('loading');
              });
          }
          else
            openPopup();
        }
      }
    });


  // FancyBox
  // --------
  $.extend(true, $.fancybox.defaults, {
    autoFocus: false,
    loop: true,
    infobar: false,
    smallBtn: true,
    buttons: [
      false,
      false,
      false,
      'close'
    ],
    idleTime: false,
    transitionEffect: 'slide',
    hash: false,
    mobile: {
      clickSlide: 'close'
    },
    lang: 'ru',
    i18n: {
      ru: {
        CLOSE: 'Закрыть',
        NEXT: 'Следующий слайд',
        PREV: 'Предыдущий слайд',
        ERROR: 'Ошибка загрузки. <br/>Пожалуйста, попробуйте позже.',
        PLAY_START: 'Запустить показ слайдов',
        PLAY_STOP: 'Остановить показ слайдов',
        FULL_SCREEN: 'В полный экран',
        THUMBS: 'Миниатюры',
        DOWNLOAD: 'Скачать',
        SHARE: 'Поделиться',
        ZOOM: 'Масштаб'
      }
    },

    beforeLoad: (widget, current) => {
      switch (current.type) {
        case 'image':
          current.opts.protect = true;
          break;

        case 'inline':
          current.opts.touch = false;
          break;
      }
    },
    afterLoad: (widget, current) => {
      if ((current.contentType === 'html') && !IS_MOBILE && !IS_MOBILE_WIDTH())
        current.$content.find('.js-autofocus-inp').trigger('focus');
    }
  });
})();